import {
  DrawerOverlay,
  DrawerHeader,
  ModalFooter,
  DrawerBody,
  useDisclosure,
  Icon,
  Drawer,
  DrawerContent,
  Stack,
  Flex,
  Text,
  useToast,
} from '@chakra-ui/react'
import { Button } from '../../../../../../components/Button'
import { BsCurrencyDollar } from 'react-icons/bs'
import { useComissoesOrcamento, useUpdateComissaoOrcamento } from '../../../../../../hooks/useComissoesOrcamento'
import { Summary } from './Summary'
import { ReferenteResumo } from './ReferenteResumo'
import { FormProvider, useForm } from 'react-hook-form'
import { QueryErrorResetBoundary } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { Suspense } from 'react'
import { formatPrice } from '../../../../../../utils/formatPrice'

function ComissoesComponent({ numeroNota, infoProposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { mutateAsync, isLoading } = useUpdateComissaoOrcamento()
  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const methods = useForm()

  const { control, handleSubmit } = methods

  const { data: infoComissoes } = useComissoesOrcamento({
    numeroNota,
    enabled: !!isOpen,
  })

  async function onSubmit(data) {
    // if (!infoComissoes?.info?.saldo_restante_devedor) {
    //   toast({
    //     title: 'Atenção',
    //     description: 'Não é possível atualizar as comissões, pois o saldo restante é maior que zero.',
    //     status: 'warning',
    //     duration: 5000,
    //     isClosable: true,
    //   })
    //   return
    // }

    const valoresParaAPI = Object.values(data.items).map((item) => ({
      codigo_vendedor: item.id_vendedor,
      valor: item.valor,
      numero_nota: item.numero_nota,
    }))

    const dados = {
      dados_atualizacao: valoresParaAPI,
    }

    await mutateAsync(dados)
  }

  return (
    <FormProvider {...methods}>
      <Button
        pointerEvents={infoProposta?.pedido_liberado ? 'none' : 'auto'}
        onClick={onOpen}
        bgColor="transparent"
        color="#2D2D2D"
        fontSize="15px"
        _hover={{
          bg: '#e2e2e2',
        }}
        fontWeight="normal"
        alignSelf="flex-start"
        border="1px solid #378BBF"
        leftIcon={<Icon as={BsCurrencyDollar} color="#378BBF" fontSize="19px" />}
      >
        Comissão Prevista: {formatPrice(infoProposta?.comissao_prevista)}
      </Button>

      <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase">
            Comissões
          </DrawerHeader>

          <DrawerBody display="flex" flexDirection="column">
            <Stack spacing={4} mb={4} px={4}>
              <Summary list={infoComissoes?.dadosGerais} />

              <ReferenteResumo list={infoComissoes?.dadosGastos} control={control} />
            </Stack>
          </DrawerBody>

          <ModalFooter display="flex" justifyContent="center" alignItems="center" gap={3} borderTop="1px solid #707070">
            <Flex alignItems="center" justifyContent="center" gap={3} fontSize="12px">
              <Flex alignItems="center" justifyContent="center" gap={2}>
                Total de Despesas Extras:
                <Text fontWeight="bold">{infoComissoes?.info?.despesas_extra}</Text>
              </Flex>
              <Flex alignItems="center" justifyContent="center" gap={2}>
                Comissão do Vendedor:
                <Text fontWeight="bold">{infoComissoes?.info?.comissao_vendedor}</Text>
              </Flex>
              <Flex alignItems="center" justifyContent="center" gap={2}>
                Saldo Restante:
                <Text color={infoComissoes?.info?.saldo_restante_devedor ? 'red' : 'green'} fontWeight="bold">
                  {infoComissoes?.info?.saldo_restante}
                </Text>
              </Flex>
              <Flex alignItems="center" justifyContent="center" gap={2}>
                A Receber:
                <Text fontWeight="bold">{infoComissoes?.info?.receber}</Text>
              </Flex>
            </Flex>
            <Button onClick={onClose} maxW="181px" w="full" ml="auto" bgColor="white" border="1px solid #378BBF" color="#378BBF">
              Voltar
            </Button>
            <Button maxW="181px" w="full" bgColor="#378BBF" color="white" onClick={handleSubmit(onSubmit)} isLoading={isLoading}>
              Salvar
            </Button>
          </ModalFooter>
        </DrawerContent>
      </Drawer>
    </FormProvider>
  )
}

export function Comissoes({ numeroNota, infoProposta }) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          FallbackComponent={({ error, resetErrorBoundary }) => (
            <div>
              Ocorreu um Erro: <pre style={{ whiteSpace: 'normal' }}>{error.message}</pre>
              <button
                onClick={() => {
                  resetErrorBoundary()
                  reset()
                }}
              >
                Tente novamente
              </button>
            </div>
          )}
          onReset={reset}
        >
          <Suspense
            fallback={
              <Button
                bgColor="transparent"
                color="#2D2D2D"
                fontWeight="bold"
                fontSize="15px"
                _hover={{
                  bg: '#e2e2e2',
                }}
                isLoading
                leftIcon={<Icon as={BsCurrencyDollar} color="#378BBF" fontSize="19px" />}
              >
                Carregando
              </Button>
            }
          >
            <ComissoesComponent numeroNota={numeroNota} infoProposta={infoProposta} />
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
